import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Faq } from "../../types"
import { initialValuesFaq, validationSchemaFaq } from "./FaqCommon"
import { useDeleteFaq, useFaq, useUpdateFaq } from "../../hooks/faqs"
import FaqForm from "./FaqForm"

export default function FaqUpdate() {
  const updateFaq = useUpdateFaq()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: faq } = useFaq(Number(id))

  const deleteFaq = useDeleteFaq()

  const [modalStateDeleteFaq, modalActionsDeleteFaq] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesFaq(faq), [faq])
  const validationSchema = useMemo(() => validationSchemaFaq(), [])

  useBreadcrumbs([{ label: "FAQs", href: "/faqs/faqs" }, { label: "Dettaglio FAQ" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{faq?.question}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteFaq.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateFaq.mutateAsync(values as Faq).then(() => {
                navigate(`/faqs/faqs`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <FaqForm />
                </Container>
                <BottomFormFixed url="/faqs/faqs" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteFaq.isOpen}
        onClose={modalActionsDeleteFaq.close}
        onDelete={() => {
          return deleteFaq.mutateAsync(faq?.id).then(() => {
            navigate(`/faqs/faqs`)
          })
        }}
        message="Sei sicuro di voler eliminare questa FAQ?"
        title="Elimina FAQ"
      />
    </Layout>
  )
}
